<p-dialog class="pop-up" [(visible)]="visible" [showHeader]="false" [modal]="true">
    <div>
        <p class="informationen">{{ ueberschrift }}</p>

        <div id="content" [innerHTML]="content"></div>

        <button class="btn-default btn" (click)="closeOverlay()">Schließen</button>
    </div>
</p-dialog>
